export default function ClearwaterAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "USPS Clearwater Main Post Office",
      address: "1001 Cleveland Street, Clearwater, FL 33755",
      phone: "(727) 443-3234",
      notes: "Passport acceptance hours Monday–Friday 9 AM–4 PM. Saturday 9 AM–12 PM. Photo service available on-site. Located in downtown Clearwater near Coachman Park.",
    },
    {
      name: "USPS St. Petersburg Main Post Office",
      address: "3135 4th Street N, St. Petersburg, FL 33704",
      phone: "(727) 821-1900",
      notes: "Passport acceptance hours Monday–Friday 8:30 AM–4 PM. Saturday 9 AM–1 PM. Photo service available. The largest USPS facility in south Pinellas County.",
    },
    {
      name: "USPS Largo Post Office",
      address: "1300 Bay Drive, Largo, FL 33770",
      phone: "(727) 585-1655",
      notes: "Passport acceptance hours Monday–Friday 9 AM–4 PM. Saturday 9 AM–12 PM. Located near Largo Central Park, convenient for north Pinellas County residents.",
    },
    {
      name: "USPS Dunedin Post Office",
      address: "900 Milwaukee Avenue, Dunedin, FL 34698",
      phone: "(727) 733-2187",
      notes: "Passport acceptance hours Monday–Friday 9 AM–4 PM. Saturday 9 AM–12 PM. Near the historic Dunedin downtown and TD Ballpark (Blue Jays spring training).",
    },
    {
      name: "Pinellas County Clerk of Circuit Court",
      address: "315 Court Street, Clearwater, FL 33756",
      phone: "(727) 464-3341",
      notes: "Offers passport acceptance services by appointment. Located in the Pinellas County Courthouse in downtown Clearwater. Call ahead for availability and required documentation.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Passport Acceptance Facilities
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit Your Passport Application Near Clearwater
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            New passports and child applications require an in-person appearance at a registered
            acceptance facility. These are the closest locations to Clearwater and surrounding
            Pinellas County communities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F8F9FB] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-9 h-9 rounded-lg bg-[#1A365D] flex items-center justify-center shrink-0">
                  <i className="ri-building-line text-white text-sm"></i>
                </div>
                <div>
                  <h3 className="font-serif text-sm font-bold text-[#1A365D] leading-tight">{f.name}</h3>
                </div>
              </div>

              <div className="space-y-2 text-sm mb-4">
                <div className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-[#F6C344] text-sm mt-0.5 shrink-0"></i>
                  <span className="text-gray-700">{f.address}</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-phone-line text-[#F6C344] text-sm mt-0.5 shrink-0"></i>
                  <span className="text-gray-700">{f.phone}</span>
                </div>
              </div>

              <p className="text-gray-600 text-xs leading-relaxed bg-white rounded-md p-3 border border-gray-100">
                {f.notes}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#1A365D] rounded-lg p-6 md:p-8 text-white">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-[#F6C344] flex items-center justify-center shrink-0">
              <i className="ri-information-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-serif text-base font-bold mb-2">Important Note About Appointments</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Many USPS passport acceptance facilities in Pinellas County operate on a walk-in basis,
                but availability varies by location and season. Spring training months (February–March)
                and spring break season (March–April) see higher demand. We recommend calling ahead
                to confirm hours and wait times. If you are using our expedited service, we will guide
                you through the acceptance process and coordinate the handoff to our registered courier
                for same-day or rush processing at the State Department.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}